import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

import { Navbar } from "./components/Navbar";
import { HeroSection } from "./components/HeroSection";
import CookieConsent from "react-cookie-consent";
import "./App.css";

// Lazy load non-critical components for better performance
const Galerija = lazy(() => import("./components/Galerija"));
const Cjenik = lazy(() => import("./components/Cjenik"));
const ServicesSection = lazy(() => 
  import("./components/ServicesSection").then(module => ({ 
    default: module.ServicesSection 
  }))
);
const Section = lazy(() => 
  import("./components/Section").then(module => ({ 
    default: module.Section 
  }))
);
const Kontakt = lazy(() => 
  import("./components/Kontakt").then(module => ({ 
    default: module.Kontakt 
  }))
);
const PolitikaPrivatnosti = lazy(() => import("./components/PolitikaPrivatnosti"));

// Loading component
const LoadingSpinner = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '200px',
    color: 'white'
  }}>
    <div>Učitavanje...</div>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Navbar />

      <Routes>
        {/* Main site */}
        <Route
          path="/"
          element={
            <>
              <HeroSection />
              <Suspense fallback={<LoadingSpinner />}>
                <Galerija />
                <Cjenik />
                <ServicesSection />
                <Kontakt />
                <Section />
              </Suspense>
            </>
          }
        />

        {/* Privacy policy */}
        <Route 
          path="/privatnost" 
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <PolitikaPrivatnosti />
            </Suspense>
          } 
        />
      </Routes>

      {/* Cookie Consent Banner - Loaded after initial render */}
      <CookieConsent
        location="bottom"
        buttonText="Prihvaćam"
        declineButtonText="Odbijam"
        enableDeclineButton
        cookieName="cookieSuglasnost"
        style={{
          background: "#2B373B",
          color: "#fff",
          textAlign: "left",
          padding: "2px",
          fontSize: "15px",
        }}
        buttonStyle={{
          background: "#f7c873",
          color: "#000",
          fontSize: "14px",
          borderRadius: "5px",
          padding: "8px 16px",
          marginRight: "10px",
        }}
        declineButtonStyle={{
          background: "#ccc",
          color: "#000",
          fontSize: "14px",
          borderRadius: "5px",
          padding: "8px 16px",
        }}
        overlay
        acceptOnScroll={false}
        acceptOnScrollPercentage={50}
      >
        Ova stranica koristi kolačiće za poboljšanje funkcionalnosti i analizu
        prometa. Korištenjem stranice pristajete na upotrebu kolačića.{" "}
        <Link
          to="/privatnost"
          style={{
            color: "#f7c873",
            textDecoration: "underline",
            marginLeft: "8px",
          }}
        >
          Više informacija
        </Link>
      </CookieConsent>

      {/* Footer */}
      <footer className="app-footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">DODO</h3>
            <p className="footer-subtitle">Obrt za usluge, proizvodnju i oglašavanje</p>
          </div>
          
          <div className="footer-section">
            <p className="footer-info">
              <strong>Vlasnik:</strong> Dominik Poznić
            </p>
            <p className="footer-info">
              <strong>Adresa:</strong> Pinezići, Potok 11
            </p>
          </div>
          
          <div className="footer-section">
            <p className="footer-copyright">
              © {new Date().getFullYear()} DODO uređenje. Sva prava pridržana.
            </p>
            <p className="footer-design">
              Design by:{" "}
              <a
                href="https://www.s3le.com.hr"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                S3le Web Design
              </a>
            </p>
          </div>
        </div>
      </footer>
    </BrowserRouter>
  );
}

export default App;
